<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Top Spender Campaign</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <BrandDropdown
            v-model="form.brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
            required="true"
            :setDisable="!!id"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrandCode" class="text-error">
            {{ error.errorBrandCode.message }}
          </div>
        </div>
        <div class="col">
          <label for="storeSelected" required>Store</label>
          <treeselect
            id="storeSelected"
            name="storeTreeSelect"
            :multiple="true"
            :clearable="true"
            :searchable="true"
            :disabled="false"
            :open-on-click="true"
            :open-on-focus="false"
            :clear-on-select="true"
            :close-on-select="false"
            :always-open="false"
            :append-to-body="false"
            :options="storeOptions"
            :limit="10"
            :value-consists-of="'LEAF_PRIORITY'"
            :max-height="200"
            v-model="form.storeCodes"
          />
          <div v-if="isSubmit && error.errorStoreCodes" class="text-error">
            {{ error.errorStoreCodes.message }}
          </div>
        </div>
      </div>
      <div class="row" v-if="id">
        <div class="col">
          <div>Link to top spender campaign on Beauty Connect</div>
          <div class="accessLink d-flex gap-2">
            <div class="pt-1">
              {{ accessLink }}
            </div>
            <button @click="copyLink">
              <font-awesome-icon
                :icon="['fas', 'copy']"
                id="copyCampaignLink"
              />
            </button>
          </div>
          <b-tooltip
            target="copyCampaignLink"
            triggers="hover"
            placement="bottom"
            variant="dark"
            >{{ copyText }}
          </b-tooltip>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="nameTh" required>Name (TH)</label>
          <input
            id="nameTh"
            v-model="form.nameTh"
            type="text"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorNameTh,
            }"
          />
          <div v-if="isSubmit && error.errorNameTh" class="text-error">
            {{ error.errorNameTh.message }}
          </div>
        </div>
        <div class="col">
          <label for="nameEn" required>Name (EN)</label>
          <input
            id="nameEn"
            v-model="form.nameEn"
            type="text"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorNameEn,
            }"
          />
          <div v-if="isSubmit && error.errorNameEn" class="text-error">
            {{ error.errorNameEn.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>Status</div>
          <input
            class="form-check-input mr-2"
            type="checkbox"
            id="checkStatus"
            v-model="form.status"
          />
          <label class="form-check-label" for="checkStatus"> Active </label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <FormTypeDropdown
            v-model="form.formTypeSelected"
            @setFormType="setFormType"
            @setFormTypes="setFormTypes"
          ></FormTypeDropdown>
          <div v-if="isSubmit && error.errorFormType" class="text-error">
            {{ error.errorFormType.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="startDatePicker" required>Start date</label>
          <div class="d-flex align-items-center gap-1">
            <date-picker
              id="startDatePicker"
              v-bind="$attrs"
              v-model="form.startDate"
              format="D MMMM yyyy"
              lang="en"
              :value="form.startDate"
              @change="
                changeStartDate($event);
                form.startDate = $event;
              "
              style="margin-top: -0.6rem"
              :class="{
                'input--error': isSubmit && error.errorStartDate,
              }"
            />
            <button
              class="btn btn-outline-secondary btn-clear"
              @click="() => (form.startDate = null)"
            >
              Clear
            </button>
          </div>

          <div v-if="isSubmit && error.errorStartDate" class="text-error">
            {{ error.errorStartDate.message }}
          </div>
        </div>
        <div class="col">
          <label for="endDatePicker" required>End date</label>
          <div class="d-flex align-items-center gap-1">
            <date-picker
              id="endDatePicker"
              v-bind="$attrs"
              v-model="form.endDate"
              format="D MMMM yyyy"
              lang="en"
              :value="form.endDate"
              :minDate="form.startDate"
              @change="form.endDate = $event"
              style="margin-top: -0.6rem"
              :class="{
                'input--error': isSubmit && error.errorEndDate,
              }"
            />
            <button
              class="btn btn-outline-secondary btn-clear"
              @click="() => (form.endDate = null)"
            >
              Clear
            </button>
          </div>

          <div v-if="isSubmit && error.errorEndDate" class="text-error">
            {{ error.errorEndDate.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="campaignDetailTh" required>Detail (TH)</label>
          <CkEditor
            id="campaignDetailTh"
            :value="form.detailTh"
            :isTh="true"
            @setContent="setContentTh"
          ></CkEditor>
          <div v-if="isSubmit && error.errorDetailTh" class="text-error">
            {{ error.errorDetailTh.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="campaignDetailEn" required>Detail (EN)</label>
          <CkEditor
            id="campaignDetailEn"
            :value="form.detailEn"
            :isTh="false"
            @setContent="setContentEn"
          ></CkEditor>
          <div v-if="isSubmit && error.errorDetailEn" class="text-error">
            {{ error.errorDetailEn.message }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <button
          class="btn btn-outline-danger"
          @click="() => $router.push({ name: 'TopSpenderCampaign' })"
        >
          Cancel
        </button>
        <button
          v-if="id"
          class="btn btn-outline-primary ml-10"
          @click="onExport"
        >
          Export
        </button>
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3>{{ message }}</h3>
          <div class="row text-center">
            <div v-if="showSuccess && id" class="col-12">
              <button class="btn-back" @click="setDefault">ตกลง</button>
            </div>
            <div v-if="showSuccess" class="col-12">
              <button
                class="btn-back"
                @click="() => $router.push({ name: 'TopSpenderCampaign' })"
              >
                กลับสู่หน้าหลัก
              </button>
            </div>
          </div>
          <div v-if="!showSuccess" class="row text-center">
            <div class="col">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown.vue";
import FormTypeDropdown from "components/TopSpenderCampaign/FormTypeDropdown.vue";
import ErrorFields from "@/views/TopSpenderCampaign/errorFields";
import StoresByRetailerService from "services/api/storesByRetailer.service";
import DatePicker from "components/Datepicker/Datepicker.vue";
import moment from "moment";
import TopSpenderCampaignService from "services/api/topSpenderCampaign.service";
import CkEditor from "components/CkEditor/CkEditor.vue";

export default {
  components: { CkEditor, DatePicker, BrandDropdown, FormTypeDropdown },
  data() {
    return {
      id: this.$route.query.id,
      message: null,
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      storeOptions: [],
      frontendHost: process.env.VUE_APP_HOST_FRONTEND,
      copyText: "copy",
      isUpdate: false,
      form: {
        nameTh: null,
        nameEn: null,
        detailTh: null,
        detailEn: null,
        status: false,
        startDate: null,
        endDate: null,
        brandSelected: null,
        storeCodes: [],
        formTypeSelected: null,
      },
      error: {
        ...ErrorFields,
      },
    };
  },
  async mounted() {
    if (this.id) {
      this.isLoading = true;
      this.isUpdate = true;
      await this.getCampaignDetail();
    }
  },
  computed: {
    accessLink() {
      if (!this.id) {
        return null;
      }
      const brandCode = this.form.brandSelected?.id ?? this.form.brandSelected;
      const formType = this.form.formTypeSelected?.value ?? this.form.formTypeSelected;
      const campaignPath =
        formType === "LUCKY_FAN" ? "lucky-fan-campaign/" : "top-spender-campaign/";
      return this.frontendHost + campaignPath + brandCode + "/" + this.id;
    },
  },
  methods: {
    async getStoresByRetailer() {
      this.isLoading = true;
      let brandCode;
      if (this.form?.brandSelected?.id) {
        brandCode = this.form.brandSelected.id;
      } else {
        brandCode = this.form.brandSelected;
      }
      const params = {
        brandCode: brandCode,
      };
      await StoresByRetailerService.getListStoresByRetailer(params)
        .then((res) => {
          this.isLoading = false;
          const data = res.data;
          this.storeOptions = data.storesByRetailer.map((s) => {
            return {
              id: s.retailerName,
              label: s.retailerName,
              children: s.stores.map((d) => {
                return {
                  id: d.storeCode,
                  label: d.storeName,
                };
              }),
            };
          });
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err);
        });
    },
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.resetErrorText();
      const form = this.form;
      const body = {
        nameTh: form.nameTh,
        nameEn: form.nameEn,
        detailTh: form.detailTh,
        detailEn: form.detailEn,
        status: form.status ? "ACTIVE" : "INACTIVE",
        startDate: moment(form.startDate).format("DD/MM/YYYY"),
        endDate: moment(form.endDate).format("DD/MM/YYYY"),
        brandCode: form.brandSelected?.id,
        storeCodes: form.storeCodes,
        formType: form.formTypeSelected?.value,
      };
      if (this.id) {
        this.updateExistingCampaign(body);
      } else {
        this.createNewCampaign(body);
      }
    },
    async createNewCampaign(body) {
      await TopSpenderCampaignService.createTopSpenderCampaign(body)
        .then((res) => {
          this.createOrUpdateSuccess(res);
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    async updateExistingCampaign(body) {
      await TopSpenderCampaignService.updateTopSpenderCampaign(body, this.id)
        .then((res) => {
          this.createOrUpdateSuccess(res);
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    createOrUpdateSuccess(res) {
      this.isLoading = false;
      const data = res.data;
      this.showDialog = true;
      this.showSuccess = true;
      this.message = data.message
        ? data.message
        : "Save Top spender campaign success";
    },
    createOrUpdateFailure(err) {
      this.isLoading = false;
      this.isUploading = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
        return;
      }
      if (errorData.message) {
        this.showDialog = true;
        this.message = errorData.message;
      }
    },
    async getCampaignDetail() {
      this.showDialog = false;
      this.isSubmit = false;
      await TopSpenderCampaignService.getDetailTopSpenderCampaign(this.id)
        .then(async (res) => {
          this.isLoading = false;

          const data = res.data.topSpenderCampaign;

          const form = this.form;
          if (data.brandCode) {
            form.brandSelected = data.brandCode;
            await this.getStoresByRetailer();
          }
          form.nameTh = data.nameTh;
          form.nameEn = data.nameEn;
          form.detailTh = data.detailTh;
          form.detailEn = data.detailEn;
          form.status = data.status === "ACTIVE";
          form.startDate = this.getLocalDate(data.startDate);
          form.endDate = this.getLocalDate(data.endDate);
          form.storeCodes = data.storeCodes;
          if (data.formType) {
            form.formTypeSelected = data.formType;
          }
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    async onExport() {
      this.isLoading = true;
      await TopSpenderCampaignService.downloadCampaignParticipants(this.id)
        .then(async (res) => {
          const downloadUrl = res.data.url;
          const link = document.createElement("a");
          link.href = downloadUrl;
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.isLoading = false;
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    setContentTh(content) {
      this.form.detailTh = content || "";
    },
    setContentEn(content) {
      this.form.detailEn = content || "";
    },
    changeStartDate(val) {
      if (val > this.form.endDate) {
        this.form.endDate = null;
      }
    },
    setBrand(brand) {
      this.form.brandSelected = brand || "";
      if (!this.isUpdate) {
        this.form.storeCodes = [];
        this.getStoresByRetailer();
      }
    },
    setBrands(brands) {
      brands.forEach((brand) => {
        if (brand.id === this.form.brandSelected) {
          this.form.brandSelected = brand;
        }
      });
    },
    setFormType(formType) {
      this.form.formTypeSelected = formType || "";
    },
    setFormTypes(formTypes) {
      formTypes.forEach((formType) => {
        if (formType.value === this.form.formTypeSelected) {
          this.form.formTypeSelected = formType;
        }
      });
    },
    setErrorText(errors) {
      this.error.errorNameTh = errors.find((e) => e.fieldName === "nameTh");
      this.error.errorNameEn = errors.find((e) => e.fieldName === "nameEn");
      this.error.errorDetailTh = errors.find((e) => e.fieldName === "detailTh");
      this.error.errorDetailEn = errors.find((e) => e.fieldName === "detailEn");
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorStartDate = errors.find(
        (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorBrandCode = errors.find(
        (e) => e.fieldName === "brandCode"
      );
      this.error.errorStoreCodes = errors.find(
        (e) => e.fieldName === "storeCodes"
      );
      this.error.errorFormType = errors.find(
        (e) => e.fieldName === "formType"
      );
    },
    resetErrorText() {
      this.error = {
        ...ErrorFields,
      };
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    copyLink() {
      navigator.clipboard.writeText(this.accessLink);
      this.copyText = "copied!";
    },
    getLocalDate(dateString) {
      return moment.utc(dateString).local().format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

label[required]::after {
  content: "*";
  color: red;
}

.campaign-loading > :not(:first-child) {
  pointer-events: none;
  opacity: 0.4;
}

::v-deep .vue-treeselect__control {
  height: 42px;
}

::v-deep .vue-treeselect__placeholder {
  align-self: center;
  font-size: 14px;
  color: #adadad;
}

.btn-clear {
  height: 100%;
  margin-top: 1px;
  white-space: nowrap;
}
</style>
